var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('copyable-field',{attrs:{"data-qa-selector":"copy-forward-email","name":_vm.s__('RightSidebar|Issue email'),"clipboard-tooltip-text":_vm.s__('RightSidebar|Copy email address'),"value":_vm.issueEmailAddress}})}
var staticRenderFns = []

export { render, staticRenderFns }